import { useMemo } from 'react'
import cn from 'clsx'

const sizes = ['xl', 'lg', 'base', 'sm', 'xs']

const defaultVariations = [
    null,
    'neutral',
    'primary',
    'secondary',
    'accent',
    'ghost',
    'link',
]

const statusVariations = [
    'info',
    'success',
    'warning',
    'error',
]

const ButtonsSection = ({
    title,
    variation = 'default',
    outline = false,
}) => {
    
    const variations = useMemo(() => {
        switch (variation) {
            case 'default': return defaultVariations
            case 'status': return statusVariations
            
            default: {
                throw new Error('Invalid variation')
            }
        }
    }, [variation])
    
    return (
        
        <section>
            
            <h4>{title}</h4>
            
            <table className="table-auto w-auto">
                <tbody>
                    {sizes.map(size => (
                        <tr key={size}>
                            <td className="font-bold">{size}</td>
                            {variations.map(it => (
                                <td key={`variation-${it}-${size}`}>
                                    <button
                                        className={cn('btn', `btn-${size}`, it ? `btn-${it}` : '', {
                                            'btn-outline': outline,
                                        })}>
                                        {it?.toUpperCase() ?? 'DEFAULT'}
                                    </button>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        
        </section>
        
    )
    
}

export default ButtonsSection
